document.addEventListener('DOMContentLoaded', function () {
    const quantityInput = document.querySelector('.quantity-input');
    const quantityActual = document.getElementById('Quantity');

    document.querySelector('.quantity-minus').addEventListener('click', function () {
        let currentValue = parseInt(quantityInput.value);
        if (currentValue > 1) {
            quantityInput.value = currentValue - 1;
            quantityActual.value = quantityInput.value;
        }
    });

    document.querySelector('.quantity-plus').addEventListener('click', function () {
        let currentValue = parseInt(quantityInput.value);
        if (currentValue < 50) {
            quantityInput.value = currentValue + 1;
            quantityActual.value = quantityInput.value;
        }
    });
});